import styled from 'styled-components';
import { isMobileBreakpoint } from 'ToolboxUtils/web/is-mobile-view';

export const NavWrapper = styled.nav`
  font-family: ${props =>
    props.theme.font.menuFont !== undefined && props.theme.font.menuFont.name};
  background: white;
  height: 60px;
  position: ${props =>
    (props.isFixed === true && 'fixed') ||
    (props.isMenuTravel === true && 'sticky') ||
    'relative'};
  top: ${props =>
    props.isMenuTravel === true || props.bannerHeight === 0 ? '0' : ''};
  bottom: ${props =>
    props.isMenuTravel === true || props.bannerHeight === 0
      ? ''
      : '-' + props.menuTravelHeight + 'px'};
  left: 0;
  right: 0;
  z-index: 8;
  
  .container {
    display: flex;
    z-index: ${props => props.isMobile ? '-1' : '30'};
    width: 100%;
    max-width: 100%;
    justify-content: ${props => props.isMobile ? 'space-around' : ''};
    
     @media (min-width: 992px) {
      .logo-no-background{
    
        img {
          height: 60px;
        }
      }
     }
    
    @media (min-width: 1200px) {
      max-width: 1140px;
      padding: 0;
    }
  }

  &.active {
    background: green;
    position: absolute;
    bottom: ${props => props.headerHeight}px;
  }

  & > div {
    padding: 10px;
    flex-grow: 1;
  }
  .logo-no-background{
    display: flex;
    align-items: center;

    img {
      object-fit:contain;
      width: 170px;
      height: 45px;
      padding: 0 20px;
    }
  }


  .logo {
    display: flex;
    align-items: center;
    background:${props => props.theme.color.primaryColor};

    img {
      object-fit: contain;
      width: 170px;
      height: 45px;
      padding: 0 20px;
    }
  }

  .select-languages {
    align-self: center;
  }

  .nav-items {
    display: flex;
    text-transform:uppercase;
    justify-content: ${props =>
      props.languages.length > 1 ? 'flex-start' : 'center'};
    padding: 10px 0;
    line-height: 1;
    margin-left: 25px;
    &::last-child {
      color: ${props => props.theme.color.primaryColor};
    }
  }
  .item {
    display: flex;
    flex-flow: column;
    flex: 1 1 0px;
    justify-content: start;
    align-items: center;
    ${props => props.theme.color.menuColor ? 'color:' + props.theme.color.menuColor + ';': ''};
    margin: 0 10px;
    font-weight: ${props => parseInt(props.theme.font.primaryFont.weight)};
    cursor: pointer;
    border-bottom: transparent solid 3px;
    &:not(.LWSkC) {
      color: ${props => props.theme.color.primaryColor};
    }
    &:hover {
      text-decoration: none;
      border-bottom: ${props => props.theme.color.primaryColor} solid 3px;
    }

    &.selected {
      background: ${props => props.theme.color.secondaryColor};
    }

    .icon {
      font-size: 36px;
      display: flex;
      vertical-align: bottom;
    }
    
     

  }
  button.item {
    background: none;
    border: none;
    &:hover {
      background: ${props => props.theme.color.secondaryColor};
    }

    &.selected {
      background: ${props => props.theme.color.secondaryColor};
    }
  }

  #mobile-nav {
    background: ${props => props.theme.color.secondaryColor};
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: space-around;
    z-index: 30;

    .item {
      padding: 5px;
      color: white;
      text-align: center;
      margin:0;
      &:hover {
        color: white;
      }

      &.selected {
        color: ${props => props.theme.color.primaryColor};
      }

      .icon {
        font-size: 34px;
        line-height: 1;
        vertical-align: bottom;
      }

      .title {
        font-size: ${props => `${(12 * props.theme.font.menuFont.scaling) / 100}px`};
        white-space: nowrap;
      }
    }
  }

  @media (min-width: ${isMobileBreakpoint}px) {
    height: 80px;
    z-index:100;

    .item {
      flex-flow: row;

      .title {
        font-size: ${props => `${(16 * props.theme.font.menuFont.scaling) / 100}px`};
        font-weight: ${props => parseInt(props.theme.font.menuFont.weight)};
        margin-left: 5px;
      }
    }
    .logo,.logo-no-background {
      margin-right: 25px;
      img {
        padding: 0 10px 0 10px;
      }
    }
    .logo.logo2, .logo-no-background.logo2 {
      img {
        width: auto;
      }
    }
    .container{   
      padding: 0 10px;
    }
  }

`;
